import { Title as Logo } from 'components/layout/title';
import { Organization, Site } from 'interfaces';
import { AdminSiteSelector } from './AdminSiteSelector';

import { Flex } from '@mantine/core';
import { DigitalClock } from './Clock';
import { ProviderSiteSelector } from './ProviderSiteSelector';
import { SiteSelector } from './SiteSelector';
import { UserSection } from './UserSection';
import { NotificationBell } from 'components/notifications/NotificationBell';
import { ChatToolbarButton } from 'components/chat/ChatManager';

interface DesktopHeaderProps {
  isAdmin: boolean;
  isProvider: boolean;
  selectedSiteID: string;
  handleSiteChange: (value: string | null) => void;
  setFetchedOrganizations: React.Dispatch<React.SetStateAction<boolean>>;
  setFetchedSites: React.Dispatch<React.SetStateAction<boolean>>;
  setSites: React.Dispatch<React.SetStateAction<Site[]>>;
  setOrganizations: React.Dispatch<React.SetStateAction<Organization[]>>;
}

export const DesktopHeader: React.FC<DesktopHeaderProps> = ({
  isAdmin,
  isProvider,
  selectedSiteID,
  handleSiteChange,
  setFetchedSites,
  setFetchedOrganizations,
  setSites,
  setOrganizations,
}) => {
  return (
    <>
      <Flex align={'center'} justify={'space-between'} gap={'md'} w="10%">
        <Logo collapsed={false} />
      </Flex>
      <Flex align="center" justify="flex-end" gap="lg" w="80%">
        <DigitalClock />
        {!isProvider && !isAdmin && (
          <SiteSelector
            selectedSiteID={selectedSiteID}
            handleSiteChange={handleSiteChange}
            setFetchedSites={setFetchedSites}
            setSites={setSites}
          />
        )}
        {isProvider && (
          <ProviderSiteSelector
            selectedSiteID={selectedSiteID}
            setOrganizations={setOrganizations}
            setSites={setSites}
            handleSiteChange={handleSiteChange}
            setFetchedOrganizations={setFetchedOrganizations}
          />
        )}
        {isAdmin && (
          <AdminSiteSelector
            isAdmin={isAdmin}
            setFetchOrganizations={setFetchedOrganizations}
            setOrganizations={setOrganizations}
            handleSiteChange={handleSiteChange}
            setSites={setSites}
            selectedSiteID={selectedSiteID}
          />
        )}
        <NotificationBell />
        <ChatToolbarButton />
        <UserSection isAdmin={isAdmin} isProvider={isProvider} />
      </Flex>
    </>
  );
};
